/**
 * Bahasa Indonesia is the default language and the source of truth for translation keys.
 * `en.ts` is typed against these keys, so a missing English string is a compile error.
 * Placeholders look like {n}.
 */
export const id = {
  // ---- common
  "common.all": "Semua",
  "common.cancel": "Batal",
  "common.choose": "Pilih…",
  "common.close": "Tutup",
  "common.edit": "Ubah",
  "common.loading": "Memuat…",
  "common.next": "Berikutnya",
  "common.prev": "Sebelumnya",
  "common.no": "Tidak",
  "common.yes": "Ya",
  "common.range": "{from}–{to} dari {total}",
  "common.remove": "Hapus",
  "common.sample": "CONTOH",
  "common.sample_hint": "Data contoh, bukan unit asli",
  "common.save": "Simpan",
  "common.storeys": "{n} lantai",

  // ---- app, nav, roles
  "nav.label": "Menu utama",
  "nav.dashboard": "Ringkasan",
  "nav.factory": "Pabrik",
  "nav.units": "Unit",
  "nav.types": "Tipe",
  "nav.handover": "Kirim ke Meda",
  "nav.growth": "Sinkron pertumbuhan",
  "nav.audit": "Jejak audit",
  "nav.settings": "Pengaturan",
  "nav.logout": "Keluar",
  "role.admin": "Admin",
  "role.worker": "Petugas pabrik",

  // ---- login and account
  "login.intro": "Masuk pakai akun staf.",
  "login.username": "Nama pengguna",
  "login.password": "Kata sandi",
  "login.submit": "Masuk",
  "account.title": "Akun saya",
  "account.must_change": "Kata sandi masih sementara. Buat kata sandi baru dulu untuk lanjut.",
  "account.current": "Kata sandi saat ini",
  "account.new": "Kata sandi baru",
  "account.again": "Ulangi kata sandi baru",
  "account.rule": "Minimal 10 karakter.",
  "account.mismatch": "Kata sandi barunya belum sama.",
  "account.submit": "Ganti kata sandi",
  "account.changed": "Kata sandi sudah diganti.",

  // ---- statuses and timeline
  "status.issued": "ID dibuat",
  "status.label_printed": "Label dicetak",
  "status.label_fixed": "Label terpasang",
  "status.shipped": "Terkirim",
  "status.void": "Dibatalkan",
  "tl.status.issued": "ID dibuat",
  "tl.status.label_printed": "Label dicetak",
  "tl.status.label_fixed": "Label dipasang",
  "tl.status.shipped": "Unit dikirim",
  "tl.status.void": "Unit dibatalkan",
  "tl.label.print": "Label dicetak",
  "tl.label.reprint": "Label dicetak ulang",
  "tl.label.fix": "Label dipasang dan dikonfirmasi",
  "tl.spec.type": "Spesifikasi tipe disalin ke unit",
  "tl.spec.unit": "Spesifikasi unit dibuat berbeda dari tipe",
  "tl.growth.factory": "Pertumbuhan dicatat pabrik",
  "tl.growth.dexss": "Pertumbuhan dicatat Meda",
  "tl.export": "Dikirim ke Meda",
  "models.title": "Model 3D",
  "models.intro": "Unggah hasil ekspor SketchUp (OBJ atau FBX) untuk ukuran ini. Sistem otomatis menyederhanakan, memampatkan, dan mengecek modelnya supaya tetap ringan di HP. Model baru bisa dipublikasikan kalau sesuai batas dan sudah punya gambar preview.",
  "models.file": "File ekspor (.zip berisi OBJ + tekstur, atau .obj / .fbx / .glb)",
  "models.units": "Satuan saat ekspor",
  "models.units_hint": "Satuan yang dipilih waktu ekspor dari SketchUp. Kalau salah, rumah akan terlihat sangat besar atau sangat kecil.",
  "models.up_axis": "Sumbu atas",
  "models.upload": "Unggah & proses",
  "models.uploaded": "Model terunggah. Sistem sedang memprosesnya.",
  "models.none": "Belum ada model 3D untuk ukuran ini.",
  "models.version": "Versi {n}",
  "models.published": "Dipublikasi",
  "models.retired": "Ditarik",
  "models.budget_ok": "Sesuai batas",
  "models.budget_fail": "Terlalu berat",
  "models.processing": "Sedang diproses. Halaman ini ikut berubah sendiri.",
  "models.metrics": "{tri} segitiga · {mb} MB · {parts} bagian · tekstur {tex} MB di memori",
  "models.reduced": "Dari {from} segitiga dan {mb0} MB di file asli",
  "models.size": "ukuran model {w} × {h} × {d} m",
  "models.too_heavy": "Model ini terlalu berat dan bisa bikin tersendat, jadi belum bisa dipublikasikan:",
  "models.poster_none": "Belum ada gambar preview. Gambar ini wajib ada sebelum dipublikasikan, karena inilah yang langsung muncul selagi model dimuat.",
  "models.poster": "Gambar preview",
  "models.preview": "Lihat 3D",
  "models.publish": "Publikasikan",
  "models.retire": "Tarik",
  "models.reprocess": "Proses ulang",
  "models.reprocess_hint": "Pakai file yang sama dengan satuan atau sumbu lain, tanpa unggah ulang.",
  "models.reprocessing": "Sedang diproses ulang.",
  "models.delete": "Hapus",
  "models.delete_confirm": "Hapus versi model ini? Filenya ikut terhapus.",
  "models.published_ok": "Model dipublikasikan.",
  "models.retired_ok": "Model ditarik.",
  "models.deleted_ok": "Model dihapus.",
  "models.poster_saved": "Gambar preview disimpan.",
  "models.poster_capture": "Pakai tampilan ini sebagai gambar preview",
  "models.poster_upload": "Unggah render sendiri",
  "models.poster_hint": "Render dari Enscape, D5, atau V-Ray biasanya paling bagus. Atur sudut model dulu, lalu ambil gambarnya.",
  "settings.look.title": "Tampilan gambar render",
  "settings.look.help": "Satu tampilan dipakai untuk semua gambar render, jadi semua model terlihat seragam. Perubahan hanya berlaku untuk gambar yang dibuat setelahnya; gambar lama tetap seperti saat dibuat. Mau lihat hasilnya? Buka model yang belum dipublikasikan, lalu tekan 'Buat gambar lagi'.",
  "settings.look.size": "Ukuran gambar",
  "settings.look.size_hint": "Dalam piksel. Gambar yang dikirim ke aplikasi dikecilkan (maks. 1600 px); versi ukuran penuh disimpan untuk cetak atau website.",
  "settings.look.quality": "Kehalusan",
  "settings.look.quality_hint": "Makin halus, makin sedikit bintik-bintik, tapi makin lama. Lamanya tergantung komputer server.",
  "settings.look.q.48": "Draf (cepat, agak berbintik)",
  "settings.look.q.96": "Seimbang (bawaan)",
  "settings.look.q.192": "Halus (± 2× lebih lama)",
  "settings.look.q.384": "Sangat halus (± 4× lebih lama)",
  "settings.look.views": "Sudut kamera",
  "settings.look.views_hint": "Satu sudut jadi satu gambar. Gambar pertama juga jadi gambar preview. Maksimal 6.",
  "settings.look.view_name": "Nama",
  "settings.look.yaw": "Putar (°)",
  "settings.look.pitch": "Tinggi (°)",
  "settings.look.add_view": "Tambah sudut",
  "settings.look.light": "Cahaya",
  "settings.look.sun_elevation": "Tinggi matahari (°)",
  "settings.look.sun_elevation_hint": "Rendah = bayangan panjang dan dramatis; tinggi = bayangan pendek.",
  "settings.look.sun_azimuth": "Arah matahari (°)",
  "settings.look.sun_azimuth_hint": "Dari arah mana cahaya datang. Ubah kalau sisi depan rumah terlihat terlalu gelap.",
  "settings.look.sun_strength": "Kuat matahari",
  "settings.look.sun_strength_hint": "Makin kuat, makin tegas bedanya antara terang dan bayangan.",
  "settings.look.sky_strength": "Cahaya langit",
  "settings.look.sky_strength_hint": "Menerangi sisi yang kena bayangan.",
  "settings.look.exposure": "Pencahayaan",
  "settings.look.exposure_hint": "Turunkan kalau dinding putih terlihat 'gosong'; naikkan kalau terlalu gelap.",
  "settings.look.colours": "Warna",
  "settings.look.backdrop_top": "Latar belakang (atas)",
  "settings.look.backdrop_bottom": "Latar belakang (bawah)",
  "settings.look.floor": "Lantai di bawah rumah",
  "settings.look.floor_hint": "Pilih warna yang kontras dengan dinding rumah.",
  "settings.look.reset": "Kembalikan ke tampilan awal",
  "settings.look.test": "Uji tampilan ini",
  "settings.look.test_hint": "Menggambar satu sudut (yang pertama) dari salah satu model, pakai tampilan yang sedang di layar, tanpa menyimpan. Hasilnya draf kasar dan agak berbintik, tapi cukup untuk menilai cahaya dan warna. Sekitar satu menit.",
  "settings.look.test_failed": "Draf gagal dibuat:",
  "settings.look.test_model": "Model yang digambar: {label}",
  "settings.look.test_draft": "Ini draf kasar. Gambar akhirnya lebih halus dan berukuran penuh.",
  "models.bundle": "Unduh paket",
  "models.bundle_hint": "Satu file .zip berisi model 3D, gambar render ukuran penuh (JPEG), gambar kecil, dan file info, untuk dipakai di luar Meda.",
  "models.renders.look": "Dibuat dengan tampilan: {w}×{h} px, kehalusan {q}",
  "models.renders.title": "Gambar render",
  "models.renders.hint": "Dibuat otomatis dari file SketchUp asli, dengan cahaya matahari dan bayangan yang nyata. Pengguna Meda langsung melihatnya, sementara model 3D dimuat di belakangnya. Gambar pertama jadi gambar preview.",
  "models.renders.waiting": "Menunggu giliran. Ada {n} render di depan; renderer mengerjakannya satu per satu.",
  "models.renders.loading": "Renderer sedang memuat model… (gambar pertama belum jadi)",
  "models.renders.step": "Gambar {k} dari {n}: {view}",
  "models.renders.eta": "sisa ± {m} menit",
  "models.renders.eta_short": "sisa kurang dari 1 menit",
  "models.renders.alive": "Sedang berjalan. Selama bar ini bergerak, semuanya normal. Boleh ditinggal.",
  "models.renders.failed": "Gambar gagal dibuat:",
  "models.renders.again": "Buat gambar lagi",
  "models.renders.again_ok": "Gambar sedang dibuat ulang.",
  "models.renders.none": "Belum ada gambar render.",
  "models.renders.view.front": "Tampak depan",
  "models.renders.view.corner": "Sudut rumah",
  "models.renders.view.aerial": "Dari atas",
  "models.perf": "Performa di perangkat ini",
  "models.perf_load": "Muncul dalam {s} dtk",
  "models.perf_fps": "≈ {fps} fps (terendah {min})",
  "models.perf_note": "Diukur di perangkat dan jaringan yang sedang dipakai. Coba juga di HP Android kelas menengah.",
  "models.loading": "Memuat model…",
  "models.no_webgl": "Browser ini tidak bisa menampilkan model 3D.",
  "models.status.queued": "Antre",
  "models.status.processing": "Memproses…",
  "models.status.ready": "Siap",
  "models.status.failed": "Gagal",
  "models.unit.m": "Meter (m)",
  "models.unit.cm": "Sentimeter (cm)",
  "models.unit.mm": "Milimeter (mm)",
  "models.unit.in": "Inci (bawaan SketchUp)",
  "models.unit.ft": "Kaki (ft)",
  "models.up.y": "Y ke atas (centang 'Swap YZ' saat ekspor)",
  "models.up.z": "Z ke atas (bawaan CAD)",

  // ---- dashboard
  "dash.title": "Ringkasan",
  "dash.awaiting_label": "Menunggu cetak label",
  "dash.awaiting_confirmation": "Menunggu konfirmasi label terpasang",
  "dash.ready_to_ship": "Siap dikirim",
  "dash.shipped": "Terkirim",
  "dash.missing_spec": "Unit belum ada spesifikasi",
  "dash.not_exported": "Belum dikirim ke Meda",
  "dash.reconcile": "Selisih dengan Meda",
  "dash.flow_title": "Alur kerja",
  "dash.flow_intro": "Urutan kerja admin, dari desain baru sampai data dikirim ke Meda. Angka menunjukkan pekerjaan yang sedang menunggu.",
  "dash.who.both": "Admin atau petugas pabrik",
  "dash.waiting": "{n} menunggu",
  "dash.open": "Buka",
  "dash.step.type": "Buat tipe dan isi spesifikasinya",
  "dash.step.type_desc": "Sekali per desain: skema pertumbuhan, ukuran, modul, posisi label, dan spesifikasi tiap ukuran. Semua unit memakainya.",
  "dash.step.issue": "Buat ID",
  "dash.step.issue_desc": "Pilih tipe dan ukuran. Tiap unit dapat ID unik dan otomatis memakai spesifikasi dari tipenya.",
  "dash.step.print": "Cetak label QR",
  "dash.step.print_desc": "Label berisi kode QR dan ID. Dicetak dari layar Pabrik, kapan saja setelah ID dibuat.",
  "dash.step.confirm": "Pasang label dan konfirmasi",
  "dash.step.confirm_desc": "Tempel label di unit, lalu konfirmasi bahwa sudah terpasang.",
  "dash.step.ship": "Kirim unit",
  "dash.step.ship_desc": "Baru bisa setelah label dikonfirmasi terpasang. Spesifikasi unit sudah ikut dari tipenya.",
  "dash.step.handover": "Kirim data ke Meda",
  "dash.step.handover_desc": "Unit yang sudah punya spesifikasi dikirim ke Meda.",
  "dash.placeholder_warn": "Link aktivasi di QR masih contoh. Isi link Meda yang asli sebelum mencetak label untuk unit sungguhan.",

  // ---- factory screen
  "factory.title": "Pabrik: cetak dan pasang label",
  "factory.find": "Ketik atau scan ID Netro",
  "factory.find_button": "Cari",
  "factory.find_hint": "Boleh ditempel dari hasil scan QR. Tanda hubung dan huruf besar/kecil tidak masalah.",
  "factory.miss.bad_check": "Karakter pemeriksanya tidak cocok, kemungkinan ada yang salah ketik. Cek lagi ID di label.",
  "factory.miss.bad_format": "Format ID tidak dikenali. Cek lagi.",
  "factory.miss.not_found": "ID ini tidak ada di sistem.",
  "factory.queue_print": "Menunggu cetak label",
  "factory.queue_confirm": "Sudah dicetak, menunggu konfirmasi terpasang",
  "factory.queue_empty": "Tidak ada unit.",
  "factory.void": "Unit ini dibatalkan. Jangan dipakai.",
  "factory.done_fixed": "Label sudah terpasang. Unit siap dikirim.",
  "factory.done_shipped": "Unit sudah dikirim.",
  "factory.open_details": "Buka detail unit",

  // ---- units list and issue dialog
  "units.title": "Unit",
  "units.issue": "Buat ID",
  "units.search": "Cari ID",
  "units.status": "Status",
  "units.type": "Tipe",
  "units.only_missing_spec": "Hanya yang belum ada spesifikasi",
  "units.empty": "Tidak ada unit yang cocok.",
  "issue.type": "Tipe",
  "issue.size": "Ukuran",
  "issue.size_hint": "Ukuran unit saat keluar dari pabrik. Ukuran ini masuk ke ID dan tidak berubah.",
  "issue.quantity": "Jumlah unit",
  "issue.production_date": "Tanggal produksi",
  "issue.date_hint": "Tahun dan bulan jadi bagian dari ID.",
  "issue.batch": "Batch (opsional)",
  "issue.batch_hint": "Kode baru dibuat otomatis.",
  "issue.sample": "Tandai sebagai data contoh/uji",
  "issue.submit": "Buat {n} ID",
  "issue.done": "{n} ID berhasil dibuat.",
  "issue.more": "dan {n} lainnya.",

  // ---- unit detail
  "unit.id": "ID Netro",
  "unit.type": "Tipe",
  "unit.client": "Klien",
  "unit.size": "Ukuran",
  "unit.size_at_production": "Ukuran saat produksi",
  "unit.current_size": "Ukuran sekarang",
  "unit.made_as": "dibuat {n} m²",
  "unit.batch": "Batch",
  "unit.production_date": "Tanggal produksi",
  "unit.shipping_date": "Tanggal kirim",
  "unit.id_format": "Versi format ID",
  "unit.late_issue": "ID dibuat setelah produksi",
  "unit.grown_note": "Unit ini sudah bertumbuh. ID tetap sama, dan bagian ukuran di ID selalu ukuran saat produksi.",
  "unit.spec": "Spesifikasi",
  "unit.exported": "Ke Meda",
  "unit.identity": "Identitas",
  "unit.label": "Label QR",
  "unit.placement": "Letak label",
  "unit.placement_none": "Letak label untuk tipe ini belum dicatat.",
  "unit.checklist": "Kelengkapan",
  "unit.check.label": "Label terpasang",
  "unit.check.spec": "Spesifikasi",
  "unit.check.shipped": "Unit terkirim",
  "unit.check.exported": "Dikirim ke Meda",
  "unit.tab.overview": "Ringkasan",
  "unit.tab.spec": "Spesifikasi",
  "unit.tab.growth": "Pertumbuhan",
  "unit.tab.history": "Riwayat",
  "unit.tab.handover": "Kirim data",
  "unit.not_exported": "Unit ini belum dikirim ke Meda.",
  "unit.ship": "Kirim unit",
  "unit.ship_no_spec": "Unit belum boleh keluar pabrik tanpa spesifikasi. Spesifikasi cukup diisi sekali di tipe, lalu dipakai tiap unit. Untuk unit lama, terapkan lewat tab Spesifikasi.",
  "unit.shipped_ok": "Unit ditandai sudah dikirim.",
  "unit.void": "Batalkan ID",
  "unit.void_banner": "ID ini sudah dibatalkan dan tidak dipakai lagi.",
  "unit.void_reason": "Alasan pembatalan",
  "unit.void_warn": "ID yang dibatalkan tidak akan dihapus atau dipakai lagi. Hanya bisa dibatalkan sebelum label dipasang.",
  "unit.voided_ok": "ID dibatalkan.",

  // ---- label
  "label.print": "Cetak label",
  "label.reprint": "Cetak ulang",
  "label.confirm": "Label sudah terpasang",
  "label.confirm_hint": "Tekan setelah label benar-benar menempel di unit. Sebelum itu, unit belum bisa dikirim.",
  "label.reason": "Alasan cetak ulang",
  "label.reason_hint": "Contoh: rusak, tergores, hilang.",
  "label.copies": "Jumlah salinan",
  "label.reprint_warn": "Label yang sudah terpasang dianggap belum terkonfirmasi sampai label baru dipasang dan dikonfirmasi.",
  "label.preview": "Preview label",
  "label.printed_ok": "Label sudah dibuat. Cetak file PDF yang terbuka.",
  "label.confirmed_ok": "Label ditandai sudah terpasang.",
  "label.print_count": "Sudah dicetak {n}×",
  "label.fixed_at": "terpasang {when}",
  "label.qr_contains": "Isi kode QR",

  // ---- spec
  "spec.title": "Spesifikasi unit",
  "spec.version": "Versi",
  "spec.latest": "Terbaru",
  "spec.from_template": "Unit ini belum punya spesifikasi (ID-nya dibuat sebelum aturan ini ada). Nilai di bawah adalah spesifikasi tipe untuk ukuran ini. Terapkan ke unit ini dengan satu klik.",
  "spec.viewing_old": "Melihat versi {n} (hanya bisa dibaca).",
  "spec.recorded": "Versi {v} dicatat oleh {who} pada {when}",
  "spec.required": "Wajib diisi",
  "spec.required_progress": "Kolom wajib yang terisi: {filled} dari {total}.",
  "spec.inherited": "Spesifikasi ini disalin dari tipe saat ID dibuat. Semua unit dengan tipe dan ukuran yang sama memakainya, jadi tidak perlu diisi satu per satu.",
  "spec.deviation_banner": "Spesifikasi unit ini berbeda dari tipenya. Versi 1 adalah spesifikasi dari tipe.",
  "spec.deviation_warn": "Ini mencatat perbedaan dari spesifikasi tipe, khusus untuk satu unit ini. Pakai hanya kalau unit ini memang berbeda, misalnya permintaan khusus pembeli.",
  "spec.record_deviation": "Catat perbedaan",
  "spec.reason": "Alasan (wajib)",
  "spec.reason_hint": "Contoh: permintaan khusus pembeli, ganti material.",
  "spec.save_deviation": "Simpan perbedaan",
  "spec.source.type": "dari tipe",
  "spec.source.unit": "beda dari tipe",
  "spec.source.manual": "diisi manual",
  "spec.add_row": "Tambah baris",
  "spec.row": "Baris {n}",
  "spec.rows_empty": "Belum ada baris.",
  "spec.openings_summary": "Luas bukaan (dihitung dari tabel)",
  "spec.openings_total": "Total",
  "spec.confirm_save": "Terapkan spesifikasi tipe ke unit ini",
  "spec.saved": "Spesifikasi disimpan.",
  "equip.add_room": "Tambah ruangan",
  "equip.add_item": "Tambah barang",
  "equip.other_room": "Ruangan lain…",
  "equip.other_item": "Barang lain…",
  "equip.room_name": "Nama ruangan",
  "equip.item_name": "Nama barang",
  "equip.remove_room": "Hapus ruangan",
  "equip.empty": "Belum ada ruangan.",
  "excel.import": "Impor dari Excel",
  "excel.export": "Unduh Excel",
  "excel.help": "Unduh lembar Excel, isi di Excel, lalu impor lagi. Impor hanya mengisi formulir: periksa dulu, lalu Simpan.",
  "excel.downloaded": "Excel diunduh.",
  "excel.imported": "Terisi dari Excel: {fields} kolom, {rows} baris. Periksa dulu, lalu Simpan.",
  "excel.nothing": "Tidak ada isian yang bisa dibaca dari file ini.",
  "excel.warn_value": "Kolom {field} dilewati: {detail}",
  "excel.warn_row": "{field}, baris {row} dilewati: {detail}",
  "group.geometry": "Geometri",
  "group.envelope": "Selubung bangunan",
  "group.energy": "Energi",
  "group.systems": "Sistem bangunan",
  "group.quality": "Referensi mutu",
  "ftype.number": "Angka",
  "ftype.text": "Teks",
  "ftype.choice": "Pilihan",
  "ftype.boolean": "Ya/Tidak",
  "ftype.date": "Tanggal",
  "ftype.url": "Tautan",
  "ftype.table": "Tabel",
  "opt.window": "Jendela",
  "opt.door": "Pintu",
  "opt.1": "Lantai 1",
  "opt.2": "Lantai 2",
  "opt.3": "Lantai 3",
  "opt.all": "Semua lantai",
  "opt.front": "Depan",
  "opt.back": "Belakang",
  "opt.left": "Kiri",
  "opt.right": "Kanan",
  "opt.wall": "Dinding",
  "opt.floor": "Lantai",
  "opt.roof": "Atap",

  // ---- growth
  "growth.scheme": "Skema pertumbuhan",
  "growth.legend_start": "ukuran saat produksi",
  "growth.legend_current": "garis tebal: ukuran sekarang",
  "growth.records": "Catatan pertumbuhan",
  "growth.add": "Catat pertumbuhan",
  "growth.edit": "Ubah catatan pertumbuhan",
  "growth.at_end": "Unit ini sudah di langkah terakhir skema, jadi tidak ada ukuran berikutnya.",
  "growth.none": "Belum ada catatan pertumbuhan.",
  "growth.date": "Tanggal",
  "growth.date_hint": "Tidak boleh sebelum tanggal produksi.",
  "growth.change": "Perubahan",
  "growth.modules": "Modul",
  "growth.modules_hint": "Terisi otomatis dari selisih modul antara dua ukuran. Boleh diubah.",
  "growth.no_catalogue": "Belum ada modul di katalog (Pengaturan → Modul).",
  "growth.source": "Sumber",
  "growth.src_factory": "Pabrik",
  "growth.state": "Status",
  "growth.current": "Berlaku",
  "growth.void": "Dibatalkan",
  "growth.from": "Dari ukuran",
  "growth.to": "Ke ukuran",
  "growth.note": "Catatan",
  "growth.saved": "Pertumbuhan disimpan.",
  "growth.voided": "Catatan pertumbuhan dibatalkan.",
  "growth.void_action": "Batalkan catatan",
  "growth.void_reason": "Alasan",
  "growth.void_warn": "Catatan tidak dihapus. Pembatalan ditambahkan sebagai versi baru, dan ukuran unit kembali ke catatan sebelumnya.",
  "growth.rules": "Unit hanya bisa tumbuh ke langkah berikutnya di skema tipenya sendiri. Hanya catatan terbaru yang bisa diubah atau dibatalkan, dan setiap perubahan membuat versi baru.",

  // ---- growth sync
  "growthsync.title": "Sinkron pertumbuhan dengan Meda",
  "growthsync.how": "Pertumbuhan dicatat di dua tempat: di sini oleh pabrik (modul yang diproduksi), dan di Meda oleh pemilik. Tidak ada yang menimpa yang lain. Selisihnya ditampilkan di bawah supaya admin bisa menyelesaikannya.",
  "growthsync.import": "Impor catatan dari Meda",
  "growthsync.import_text": "Pilih file JSON catatan pertumbuhan dari Meda. Mengimpor file yang sama dua kali itu aman.",
  "growthsync.choose_file": "Pilih file JSON",
  "growthsync.format": "Format file",
  "growthsync.imported": "{n} catatan baru diimpor.",
  "growthsync.result": "Diterima {received}, baru {created}, sudah ada {dup}, error {err}.",
  "growthsync.reconcile": "Selisih yang perlu dicek",
  "growthsync.reconcile_text": "Unit yang ukurannya beda antara pabrik dan Meda.",
  "growthsync.in_sync": "Tidak ada selisih. Pabrik dan Meda sama.",
  "growthsync.factory": "Pabrik",
  "growthsync.issue": "Masalah",
  "growthsync.factory_missing": "Meda mencatat ukuran lebih besar, tapi pabrik belum mencatatnya",
  "growthsync.size_mismatch": "Ukuran berbeda",

  // ---- handover
  "handover.title": "Kirim data ke Meda",
  "handover.tab.export": "Buat file",
  "handover.tab.log": "Riwayat pengiriman",
  "handover.what": "File ini berisi, per unit: ID, tipe beserta skema pertumbuhannya, spesifikasi, tanggal produksi dan kirim, catatan pertumbuhan, dan link aktivasi label. File JSON adalah format lengkapnya; CSV hanya ringkasan.",
  "handover.choose": "Unit yang dikirim",
  "handover.by_units": "Pilih unit",
  "handover.by_batch": "Satu batch",
  "handover.batch_hint": "Unit yang dibatalkan dilewati.",
  "handover.include_sent": "Tampilkan juga yang pernah dikirim",
  "handover.none_to_send": "Tidak ada unit untuk dikirim.",
  "handover.selected": "{n} unit dipilih",
  "handover.n_units": "{n} unit",
  "handover.check": "Pengecekan",
  "handover.pick_first": "Pilih unit atau batch dulu.",
  "handover.missing_spec": "Unit ini belum punya spesifikasi. Terapkan spesifikasi tipenya dulu:",
  "handover.has_void": "Ada unit yang dibatalkan di pilihan. Keluarkan dulu.",
  "handover.already": "{n} unit pernah dikirim. Kirim ulang perlu dikonfirmasi.",
  "handover.ready": "Semua unit siap dikirim.",
  "handover.format": "Format",
  "handover.format_json": "lengkap",
  "handover.format_csv": "ringkasan",
  "handover.export": "Buat dan unduh file",
  "handover.done": "File {name} sudah dibuat dan dicatat.",
  "handover.again_title": "Kirim ulang?",
  "handover.again_text": "{n} unit sudah pernah dikirim ke Meda. File baru akan dicatat sebagai pengiriman ulang.",
  "handover.again_confirm": "Ya, kirim ulang",
  "handover.log_empty": "Belum ada pengiriman.",
  "handover.when": "Waktu",
  "handover.who": "Oleh",
  "handover.file": "File",
  "handover.units": "Unit",
  "handover.checksum": "SHA-256",
  "handover.reexport": "kirim ulang",
  "handover.download": "Unduh",
  "handover.sync.title": "Sinkron ke Meda",
  "handover.sync.what": "Kirim semua tipe dan semua unit yang sudah punya spesifikasi ke Meda sekaligus, dengan satu klik. Aman diulang: Meda hanya memperbarui data yang sudah dimilikinya.",
  "handover.sync.button": "Sinkron sekarang",
  "handover.sync.target": "Tujuan: {target}",
  "handover.sync.off": "Sambungan ke Meda belum diatur. Isi Meda_SYNC_URL dan Meda_SYNC_TOKEN di file .env, lalu jalankan ulang aplikasinya.",
  "handover.sync.never": "Belum pernah sinkron.",
  "handover.sync.last_ok": "Sinkron terakhir {when} oleh {who}: {types} tipe, {units} unit.",
  "handover.sync.last_fail": "Percobaan terakhir {when} gagal. {error}",
  "handover.sync.done": "Selesai: {types} tipe dan {units} unit sudah terkirim.",
  "handover.sync.skipped": "{n} unit tidak ikut karena belum punya spesifikasi: {ids}",
  "handover.sync.badge": "sinkron",
  "handover.sync.badge_failed": "gagal",

  // ---- types
  "types.title": "Tipe Netro",
  "types.intro": "Satu tipe = satu desain. Kalau desainnya berubah, buat tipe baru. Klien/pengembang hanya disimpan di tipe, bukan di ID.",
  "types.new": "Tipe baru",
  "types.empty": "Belum ada tipe.",
  "types.code": "Kode tipe",
  "types.code_hint": "Harus pas sesuai panjang di format ID, huruf A–Z atau angka. Tidak bisa diubah setelah ada unit.",
  "types.name": "Nama",
  "types.description": "Deskripsi",
  "types.client": "Klien/pengembang",
  "types.client_hint": "Kosongkan untuk tipe umum.",
  "types.new_client": "Klien baru",
  "types.new_client_hint": "Klien baru langsung terpilih untuk tipe ini setelah disimpan.",
  "types.client_added": "Klien ditambahkan dan dipilih: {name}",
  "types.general": "Tipe umum",
  "types.units": "Unit",
  "types.scheme": "Skema pertumbuhan",
  "types.scheme_help": "Urutan ukuran yang bisa dicapai unit tipe ini. Tiap langkah juga ukuran yang boleh diproduksi di pabrik. Satu tipe tidak boleh punya ukuran yang sama dua kali.",
  "types.retired": "tidak dipakai lagi",
  "types.header": "Data tipe",
  "types.placement": "Posisi label di unit",
  "types.placement_hint": "Tampil di layar pabrik supaya label selalu ditempel di posisi yang sama.",
  "types.active": "Aktif (boleh membuat ID baru)",
  "types.is_sample": "Data contoh",
  "types.add_step": "Tambah langkah",
  "types.step": "Langkah {n}",
  "types.step_base": "Tipe dasar",
  "types.size": "Ukuran",
  "types.storeys": "Jumlah lantai",
  "types.producible": "Boleh diproduksi di pabrik",
  "types.modules": "Modul di langkah ini",
  "types.add_module": "Tambah modul",
  "types.quantity": "Jumlah",
  "types.modules_hint": "Susunan modul unit di ukuran ini.",
  "types.template": "Spesifikasi untuk ukuran ini",
  "types.template_hint": "Isi sekali di sini. Semua unit ukuran ini otomatis memakainya, jadi tidak perlu diisi lagi per unit. ID baru belum bisa dibuat sebelum kolom wajibnya lengkap.",
  "types.spec_complete": "Lengkap",
  "types.spec_incomplete": "{n} kolom wajib belum diisi",
  "types.spec_applies_new": "Unit yang sudah dibuat tidak berubah. Perubahan hanya berlaku untuk unit yang dibuat setelahnya.",
  "types.move_up": "Naikkan",
  "types.move_down": "Turunkan",
  "types.create": "Buat tipe",
  "types.created": "Tipe dibuat.",
  "types.saved": "Tipe disimpan.",
  "types.locked": "Sudah ada {n} unit untuk tipe ini, jadi kode, ukuran, urutan, dan jumlah lantai dikunci. Kalau desainnya berubah, buat tipe baru. Nama, catatan, modul, template, dan langkah baru di akhir masih bisa diubah.",

  // ---- audit
  "audit.title": "Jejak audit",
  "audit.intro": "Setiap pembuatan, perubahan, cetak ulang, pertumbuhan, dan pengiriman dicatat lengkap dengan siapa dan kapan. Catatan ini tidak bisa diubah atau dihapus, bahkan lewat database.",
  "audit.entity": "ID / kode",
  "audit.user": "Pengguna",
  "audit.action": "Aksi",
  "audit.when": "Waktu",
  "audit.what": "Keterangan",
  "audit.details": "Lihat sebelum/sesudah",
  "audit.before": "Sebelum",
  "audit.after": "Sesudah",
  "audit.empty": "Tidak ada catatan.",

  // ---- settings
  "settings.saved": "Tersimpan.",
  "settings.active": "Aktif",
  "settings.tab.idformat": "Format ID",
  "settings.tab.label": "Label",
  "settings.tab.activation": "Tautan aktivasi",
  "settings.tab.models3d": "Model 3D",
  "settings.models.title": "Batas model 3D",
  "settings.models.help": "Batas yang harus dipenuhi model supaya terasa mulus di HP. Ini baru titik awal: ubah setelah dicoba di HP Android kelas menengah. Model yang melewati batas tidak bisa dipublikasikan.",
  "settings.models.triangles": "Jumlah segitiga maksimum",
  "settings.models.triangles_hint": "Makin banyak makin detail, tapi makin berat.",
  "settings.models.size": "Ukuran file maksimum",
  "settings.models.size_hint": "Yang diunduh pengguna lewat data seluler.",
  "settings.models.texture": "Ukuran tekstur maksimum",
  "settings.models.texture_hint": "Tekstur yang lebih besar dari ini otomatis dikecilkan.",
  "settings.models.parts": "Jumlah bagian maksimum",
  "settings.models.parts_hint": "Terlalu banyak bagian terpisah bikin HP tersendat.",
  "settings.models.memory": "Memori tekstur maksimum",
  "settings.models.memory_hint": "Memori grafis yang dipakai tekstur. HP murah paling cepat kehabisan di sini.",
  "settings.models.encoding_title": "Format file",
  "settings.models.encoding": "Kompresi",
  "settings.models.encoding_efficient": "Efisien (paling kecil dan cepat)",
  "settings.models.encoding_compatible": "Kompatibel (bisa dibuka di viewer 3D mana pun)",
  "settings.models.encoding_efficient_hint": "File jauh lebih kecil dan ringan di memori, tapi viewer-nya harus mendukung WebP, kuantisasi mesh, dan meshopt. Viewer di aplikasi ini sudah mendukung; tim Meda perlu memastikan hal yang sama.",
  "settings.models.encoding_compatible_hint": "Tanpa kompresi khusus: bisa dibuka di viewer glTF mana pun tanpa dekoder tambahan, tapi file lebih besar dan lebih sulit memenuhi batas ukuran.",
  "settings.models.base_title": "Alamat file untuk Meda",
  "settings.models.base": "Alamat publik server ini",
  "settings.models.base_hint": "Awalan alamat yang dipakai Meda untuk mengambil model, misalnya alamat server ini atau CDN di depannya. Kosongkan untuk alamat relatif.",
  "settings.tab.fields": "Kolom spesifikasi",
  "settings.tab.modules": "Modul",
  "settings.tab.clients": "Klien",
  "settings.tab.batches": "Batch",
  "settings.tab.users": "Pengguna",
  "settings.id.title": "Format ID Netro",
  "settings.id.help": "Format sekarang versi {v}. Perubahan hanya berlaku untuk ID baru. Unit yang sudah ada tetap memakai formatnya, dan label lama tetap berlaku. Kode tipe harus sepanjang yang diatur di sini.",
  "settings.id.prefix": "Awalan",
  "settings.id.type_len": "Panjang kode tipe",
  "settings.id.size_len": "Digit ukuran (m²)",
  "settings.id.period": "Format tahun-bulan",
  "settings.id.seq_len": "Digit nomor urut",
  "settings.id.separator": "Pemisah",
  "settings.id.check": "Karakter pemeriksa",
  "settings.id.check_hint": "Menangkap salah ketik satu karakter dan dua karakter yang tertukar saat ID diketik manual.",
  "settings.id.none": "tanpa",
  "settings.id.example": "Contoh ID",
  "settings.id.length": "{n} karakter",
  "settings.label.title": "Ukuran dan jenis cetak label",
  "settings.label.help": "Ukuran label dan jenis printer belum ditentukan. Atur di sini; PDF mengikuti pengaturan ini.",
  "settings.label.mode": "Mode cetak",
  "settings.label.sheet": "Lembar A4 (printer biasa)",
  "settings.label.single": "Satu label per halaman (printer label)",
  "settings.label.mode_sheet": "Label disusun berderet di kertas A4.",
  "settings.label.mode_single": "Ukuran halaman PDF sama dengan ukuran label.",
  "settings.label.width": "Lebar label",
  "settings.label.height": "Tinggi label",
  "settings.label.margin": "Margin kertas",
  "settings.label.gap": "Jarak antar label",
  "settings.label.ec": "Koreksi error QR",
  "settings.label.ec_hint": "Makin tinggi, QR tetap terbaca walau tergores, tapi kodenya jadi lebih rapat.",
  "settings.label.guides": "Garis potong putus-putus",
  "settings.label.preview": "Preview",
  "settings.label.preview_hint": "Preview memakai unit terbaru dan pengaturan yang sudah disimpan.",
  "settings.label.no_unit": "Buat satu ID dulu untuk melihat preview.",
  "settings.label.too_small": "Label terlalu kecil untuk QR yang bisa discan. Perbesar ukuran label.",
  "settings.act.title": "Tautan aktivasi Meda",
  "settings.act.help": "QR berisi satu link: alamat ini diikuti ID Netro. Teknisi lapangan men-scan-nya pakai aplikasi Meda untuk memasangkan Smartbox.",
  "settings.act.base": "Alamat dasar",
  "settings.act.hint": "Tanpa ID di ujungnya, contoh: https://…/aktivasi",
  "settings.act.example": "Contoh isi QR",
  "settings.act.placeholder": "Alamat ini masih contoh dan tidak bisa dibuka. Isi alamat Meda yang asli sebelum mencetak label untuk unit sungguhan.",
  "settings.fields.help": "Daftar kolom spesifikasi dikelola lewat konfigurasi. Kunci, kelompok, dan jenis kolom tidak bisa diubah setelah dibuat, karena spesifikasi lama bergantung padanya. Kolom yang sudah tidak dipakai dinonaktifkan, bukan dihapus.",
  "settings.fields.add": "Tambah kolom",
  "settings.fields.label": "Label",
  "settings.fields.key": "Kunci",
  "settings.fields.key_hint": "huruf kecil, angka, garis bawah",
  "settings.fields.fixed": "Tidak bisa diubah",
  "settings.fields.group": "Kelompok",
  "settings.fields.type": "Jenis",
  "settings.fields.unit": "Satuan",
  "settings.fields.label_id": "Label (Bahasa Indonesia)",
  "settings.fields.label_en": "Label (English)",
  "settings.fields.choices": "Pilihan",
  "settings.fields.choices_hint": "Pisahkan dengan koma",
  "settings.fields.required": "Wajib (dihitung dalam kelengkapan)",
  "settings.fields.table_note": "Ini kolom tabel. Isinya diatur sistem; yang bisa diubah di sini hanya label, wajib, dan status aktif.",
  "settings.modules.help": "Katalog modul. Susunan modul tiap langkah tipe dan catatan pertumbuhan merujuk ke sini.",
  "settings.modules.add": "Tambah modul",
  "settings.modules.empty": "Belum ada modul.",
  "settings.modules.code_fixed": "Kode tidak bisa diubah. Nonaktifkan modulnya, lalu buat yang baru.",
  "settings.clients.help": "Klien/pengembang yang bisa dipilih di data tipe. Nama klien tidak pernah masuk ke ID.",
  "settings.clients.add": "Tambah klien",
  "settings.clients.name": "Nama klien",
  "settings.clients.empty": "Belum ada klien.",
  "settings.batches.help": "Batch mengelompokkan unit yang diproduksi bersamaan. Batch juga dibuat otomatis saat membuat ID.",
  "settings.batches.add": "Tambah batch",
  "settings.batches.code": "Kode batch",
  "settings.batches.code_hint": "Huruf, angka, titik, strip, garis miring.",
  "settings.batches.note": "Catatan",
  "settings.batches.empty": "Belum ada batch.",
  "settings.users.help": "Ada dua peran: admin (akses ke semua data) dan petugas pabrik (cetak label dan konfirmasi pemasangan).",
  "settings.users.add": "Tambah pengguna",
  "settings.users.name": "Nama lengkap",
  "settings.users.role": "Peran",
  "settings.users.last_login": "Masuk terakhir",
  "settings.users.you": "Anda",
  "settings.users.disabled": "nonaktif",
  "settings.users.reset": "Atur ulang kata sandi",
  "settings.users.reset_hint": "Kosongkan kalau tidak diganti. Pengguna akan diminta membuat kata sandi sendiri saat masuk.",
  "settings.users.temp_hint": "Kata sandi sementara, minimal 10 karakter. Pengguna menggantinya saat pertama kali masuk.",
  "settings.users.username_hint": "huruf kecil, angka, titik, strip",

  // ---- errors (codes from the API)
  "err.unknown": "Ada yang tidak beres. Coba lagi.",
  "err.network": "Tidak bisa terhubung ke server.",
  "err.validation": "Ada isian yang belum benar. Cek lagi.",
  "err.conflict": "Data ini baru saja diubah di tempat lain. Muat ulang, lalu coba lagi.",
  "err.csrf": "Permintaan ditolak. Muat ulang halaman.",
  "err.not_authenticated": "Silakan masuk dulu.",
  "err.session_expired": "Sesi sudah habis. Silakan masuk lagi.",
  "err.account_disabled": "Akun ini dinonaktifkan.",
  "err.account_locked": "Terlalu banyak percobaan yang gagal. Coba lagi beberapa menit lagi.",
  "err.invalid_credentials": "Nama pengguna atau kata sandi salah.",
  "err.wrong_password": "Kata sandi saat ini salah.",
  "err.password_too_short": "Kata sandi minimal {n} karakter.",
  "err.forbidden": "Hanya admin yang bisa melakukan ini.",
  "err.username_taken": "Nama pengguna sudah dipakai.",
  "err.user_not_found": "Pengguna tidak ditemukan.",
  "err.last_admin": "Harus selalu ada minimal satu admin yang aktif.",
  "err.id_format_missing": "Format ID belum diatur.",
  "err.invalid_id_format": "Format ID tidak valid.",
  "err.client_exists": "Klien dengan nama itu sudah ada.",
  "err.client_not_found": "Klien tidak ditemukan.",
  "err.module_code_taken": "Kode modul sudah dipakai.",
  "err.module_not_found": "Modul tidak ditemukan.",
  "err.module_code_fixed": "Kode modul tidak bisa diubah.",
  "err.duplicate_module": "Satu modul hanya boleh muncul sekali.",
  "err.spec_key_taken": "Kunci kolom sudah dipakai.",
  "err.choices_required": "Kolom pilihan butuh minimal satu pilihan.",
  "err.choices_not_allowed": "Hanya kolom pilihan yang punya pilihan.",
  "err.spec_field_not_found": "Kolom tidak ditemukan.",
  "err.batch_exists": "Batch dengan kode itu sudah ada.",
  "err.type_not_found": "Tipe tidak ditemukan.",
  "err.invalid_type_code": "Kode tipe harus tepat {n} karakter, huruf A–Z atau angka.",
  "err.type_code_taken": "Kode tipe sudah dipakai.",
  "err.duplicate_size": "Satu ukuran hanya boleh muncul sekali dalam skema.",
  "err.size_too_large": "Ukuran terlalu besar untuk format ID.",
  "err.no_producible_step": "Minimal satu langkah harus boleh diproduksi.",
  "err.step_not_found": "Langkah tidak ditemukan.",
  "err.duplicate_step": "Satu langkah muncul dua kali.",
  "err.type_locked": "Sudah ada unit untuk tipe ini. Kode, ukuran, urutan, dan jumlah lantai tidak bisa diubah. Kalau desainnya berubah, buat tipe baru.",
  "err.type_inactive": "Tipe ini sudah tidak dipakai lagi.",
  "err.type_code_not_valid_for_format": "Kode tipe tidak sesuai format ID saat ini.",
  "err.step_not_in_scheme": "Ukuran itu bukan bagian dari skema tipe ini.",
  "err.step_not_producible": "Ukuran ini tidak boleh diproduksi di pabrik.",
  "err.production_date_out_of_range": "Tanggal produksi terlalu jauh dari hari ini. Cek tahun dan bulannya, karena keduanya jadi bagian dari ID.",
  "err.sequence_exhausted": "Nomor urut tipe ini untuk bulan ini sudah habis.",
  "err.unit_not_found": "Unit tidak ditemukan.",
  "err.unit_void": "Unit yang dibatalkan tidak bisa diubah.",
  "err.reprint_reason_required": "Isi alasan cetak ulang.",
  "err.label_not_printed": "Cetak label dulu, lalu konfirmasi bahwa sudah terpasang.",
  "err.label_not_fixed": "Label harus dikonfirmasi terpasang sebelum unit dikirim.",
  "err.spec_missing": "Unit belum punya spesifikasi. Lengkapi spesifikasi tipe, lalu terapkan, sebelum unit dikirim.",
  "err.shipping_before_production": "Tanggal kirim tidak boleh sebelum tanggal produksi.",
  "err.cannot_void": "Hanya unit yang labelnya belum terpasang yang bisa dibatalkan.",
  "err.label_too_small": "Label terlalu kecil untuk QR yang bisa discan. Perbesar ukuran label di Pengaturan.",
  "err.label_does_not_fit_page": "Ukuran label tidak muat di kertas A4.",
  "err.nothing_to_print": "Tidak ada label untuk dicetak.",
  "err.invalid_spec_value": "Ada isian spesifikasi yang tidak valid.",
  "err.spec_reason_required": "Isi alasan perbedaan dari spesifikasi tipe.",
  "err.type_spec_incomplete": "Lengkapi dulu spesifikasi ukuran {n} m² di tipe (Tipe → ukuran → Spesifikasi untuk ukuran ini).",
  "err.unknown_spec_field": "Ada kolom spesifikasi yang tidak dikenal.",
  "err.excel_not_xlsx": "Ini bukan file Excel (.xlsx).",
  "err.excel_too_large": "File terlalu besar (maksimal 2 MB).",
  "err.excel_unreadable": "File Excel tidak bisa dibaca.",
  "err.spec_exists": "Unit ini sudah punya spesifikasi.",
  "err.spec_unchanged": "Tidak ada perubahan dari versi terakhir.",
  "err.spec_version_not_found": "Versi spesifikasi tidak ditemukan.",
  "err.growth_not_forward": "Unit hanya bisa tumbuh ke langkah berikutnya dalam skema tipenya.",
  "err.growth_before_production": "Pertumbuhan tidak boleh bertanggal sebelum produksi.",
  "err.date_out_of_range": "Tanggal terlalu jauh di masa depan.",
  "err.growth_not_found": "Catatan pertumbuhan tidak ditemukan.",
  "err.growth_voided": "Catatan ini sudah dibatalkan.",
  "err.growth_not_latest": "Hanya catatan pertumbuhan terbaru yang bisa diubah atau dibatalkan.",
  "err.invalid_import": "File impor tidak valid.",
  "err.export_scope": "Pilih unit atau satu batch.",
  "err.export_has_void": "Unit yang dibatalkan tidak bisa dikirim.",
  "err.export_missing_spec": "Unit ini belum punya spesifikasi. Terapkan spesifikasi tipenya dulu sebelum mengirim.",
  "err.already_exported": "Unit ini sudah pernah dikirim ke Meda.",
  "err.nothing_to_export": "Tidak ada unit untuk dikirim.",
  "err.export_not_found": "Pengiriman tidak ditemukan.",
  "err.dexss_not_configured": "Sambungan ke Meda belum diatur.",
  "err.dexss_unreachable": "Meda tidak bisa dihubungi. Pastikan Meda menyala dan alamatnya benar.",
  "err.dexss_rejected": "Meda menolak data ini. Cek token-nya, dan pastikan kedua sisi memakai versi file yang sama.",
  "err.dexss_error": "Meda bermasalah saat menerima data. Coba lagi sebentar lagi.",
  "err.upload_too_large": "File terlalu besar.",
  "err.unsupported_model_file": "Unggah file .zip, .obj, .fbx, atau .glb.",
  "err.bad_zip": "File itu bukan zip yang valid.",
  "err.unsafe_zip": "Zip ditolak karena isinya tidak aman atau terlalu besar.",
  "err.no_model_in_zip": "Di dalam zip tidak ada file .obj, .fbx, atau .glb.",
  "err.ambiguous_model": "Zip berisi lebih dari satu model. Zip satu model saja.",
  "err.model_not_found": "Model tidak ditemukan.",
  "err.model_not_ready": "Model belum siap.",
  "err.model_published": "Model yang sudah dipublikasikan tidak bisa diubah. Unggah versi baru.",
  "err.model_busy": "Model masih diproses.",
  "err.model_not_published": "Model ini bukan yang sedang dipublikasikan.",
  "err.over_budget": "Model terlalu berat untuk pengalaman yang mulus. Ekspor versi yang lebih ringan, atau ubah batasnya di Pengaturan.",
  "err.poster_required": "Atur gambar preview dulu: ini yang langsung muncul selagi model dimuat.",
  "err.unsupported_image": "Gambar harus berformat PNG, JPEG, atau WebP.",
  "err.poster_failed": "Gambar preview gagal diproses.",
  "err.poster_missing": "Belum ada gambar preview.",
  "err.look_test_busy": "Draf lain masih dibuat. Tunggu sebentar.",
  "err.no_model_for_test": "Unggah model 3D dulu. Uji tampilan menggambar salah satu model yang sudah ada.",
  "err.render_missing": "Gambar tidak ditemukan.",
  "err.no_test_picture": "Belum ada gambar uji.",
} as const;

export type Key = keyof typeof id;
